import handleToken from '@/libs/backend/restAPI/handleToken';
import Vue from 'vue';

export function handleResponseError(response: any, params: {showNotify?: boolean} = {}): any {
    const {showNotify = true} = params;
    return Promise.resolve(response)
        .then(result => {
            const checkToken = handleToken({
                data: result.data,
                status: result.status
            });
            if (showNotify) {
                if (result.status === 500) {
                    Vue.notify({
                        group: 'notice',
                        title: 'Error 500',
                        text: 'Server Error',
                        type: 'error'
                    });
                } else if (result.status === 400) {
                    if (result.data.title && result.data.detail) {
                        Vue.notify({
                            group: 'notice',
                            title: result.data.title,
                            text: result.data.detail,
                            type: 'error'
                        });
                    } else {
                        Vue.notify({
                            group: 'notice',
                            title: 'Error',
                            text: 'Changed Failed',
                            type: 'error'
                        });
                    }
                } else {
                    Vue.notify({
                        group: 'notice',
                        title: 'Error',
                        // text: result.data,
                        type: 'error'
                    });
                }
            }
            return Promise.reject(checkToken)
        })
        .catch(e => Promise.reject(e));
}
